import { z } from 'zod';

/**
 * Common validation patterns
 */
export const patterns = {
  phone: /^(\+?56)?(\s?)(9)(\s?)[98765432]\d{7}$/,
};

/**
 * Contact Form Schema
 */
export const contactFormSchema = z.object({
  name: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede exceder los 100 caracteres'),

  email: z.string().email('Por favor ingrese un correo electrónico válido'),

  phone: z
    .string()
    .min(8, 'El teléfono debe tener al menos 8 dígitos')
    .regex(patterns.phone, 'Formato de teléfono inválido'),

  subject: z
    .string()
    .min(5, 'El asunto debe tener al menos 5 caracteres')
    .max(100, 'El asunto no puede exceder los 100 caracteres'),

  message: z
    .string()
    .min(10, 'El mensaje debe tener al menos 10 caracteres')
    .max(2000, 'El mensaje no puede exceder los 2000 caracteres'),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
